'use strict';

$(document).ready(function() {
    if (!$('.pd-tabs').length) {
        return;
    }

    function refreshPanes($scope) {
        $scope.find('.tab-content > .tab-pane').each(function() {
            if ($(this).hasClass('active')) {
                this.removeAttribute('inert');
                this.removeAttribute('aria-hidden');
            } else {
                this.setAttribute('inert', '');
                this.setAttribute('aria-hidden', 'true');
            }
        });
    }

    refreshPanes($('.pd-tabs'));

    $(document).on('shown.bs.tab', '.pd-tabs [data-toggle="tab"]', function() {
        var $pdTabs = $(this).closest('.pd-tabs');
        refreshPanes($pdTabs);
        $pdTabs.find('.tab-pane.active .slider-card-travels').each(function() {
            if (this.swiper) {
                this.swiper.update();
            }
        });
    });
});
